import { useNavigate } from "react-router-dom";
import "./popularcategories.css";

export default function PopularCategories() {

  const navigate = useNavigate();

  const categories = [

    {
      title: "MUSHROOMS",

      image:
        "https://images.unsplash.com/photo-1585238342024-78d387f4a707?q=80&w=1200&auto=format&fit=crop",

      bg: "#dff5e1",

      category: "Mushrooms"
    },

    {
      title: "LEGAL DELTA 9",

      image:
        "https://images.unsplash.com/photo-1603909223429-69bb7101f420?q=80&w=1200&auto=format&fit=crop",

      bg: "#f7efc7",

      category: "Delta 9 Gummies"
    },

    {
      title: "THCA",

      image:
        "https://images.unsplash.com/photo-1600959907703-125ba1374a12?q=80&w=1200&auto=format&fit=crop",

      bg: "#f7dfe6",

      category: "THCA Flower"
    },

    {
      title: "DELTA 8 THC",

      image:
        "https://images.unsplash.com/photo-1598662957563-ee4965d4d72c?q=80&w=1200&auto=format&fit=crop",

      bg: "#eadcf8",

      category: "Delta 8"
    },

    {
      title: "THCP",

      image:
        "https://images.unsplash.com/photo-1599599810769-bcde5a160d32?q=80&w=1200&auto=format&fit=crop",

      bg: "#e3e5ff",

      category: "THCP"
    },

    {
      title: "SMOKE SHOP",

      image:
        "https://images.unsplash.com/photo-1511367461989-f85a21fda167?q=80&w=1200&auto=format&fit=crop",

      bg: "#f5f5f5",

      category: "Accessories"
    }

  ];

  return (

    <div className="popular-wrapper">

      <h2 className="popular-title">
        Popular Categories
      </h2>

      <div className="popular-grid">

        {categories.map((item, index) => (

          <div
            className="popular-card"
            key={index}
            style={{
              background: item.bg
            }}
          >

            <div className="popular-left">

              <h3>
                {item.title}
              </h3>

              <button
                onClick={() =>
                  navigate(
                    `/?category=${encodeURIComponent(
                      item.category
                    )}`
                  )
                }
              >
                VIEW MORE
              </button>

            </div>

            <div className="popular-right">

              <img
                src={item.image}
                alt=""
              />

            </div>

          </div>

        ))}

      </div>

    </div>
  );
}